<template>
    <div>
        <div class="row ">

            <div class="col-xs-6 no-margin-bottom" v-if="creditLine > 0 ">
                <strong>{{'Credit Line'|trans}}  </strong> <span class="tag tag-success monospaceText" >{{ creditLine }}</span><br>
            </div>
            <div class="col-xs-6 no-margin-bottom text-right">
                <strong>{{'Balance'|trans}}  </strong> <span class="tag tag-success monospaceText" >{{ currentBalance|roundNumber }}</span><br>
            </div>

            <div class="text-right" v-if=" initializedOnPelican === false ">
                <ModalSmall v-bind:btnOpenModalTitle="'top up my account'|trans"
                            v-bind:btnCloseModalTitle="'Close'|trans">
                    <div slot="body">
                        <h4>{{'To top up your account, please make the transfer with the desired amount to'|trans}} </h4>
                        <hr>
                        {{'Name'|trans }} : UAB IT FORMA<br>
                        {{'IBAN'|trans }} : LT147044060008156576<br>
                        {{'SWIFT/BIC'|trans }} : CBVILT2XXXX<br>
                        {{'Reference'|trans }} : PCBE{{workerId}}<br>
                        <br><br>
                        <div class="alert alert-info">
                            <i>{{'Your account will be credited within 24 hours.'|trans }}</i>
                        </div>
                        <hr>
                    </div>
                </ModalSmall>
            </div>


            <div class="col-xs-12 text-center">
                <hr>
                <h4>{{ 'Transactions' | trans }}</h4>

                <div v-if="!isNoviceWorker || creditLine > 0" class="col-xs-12 text-center alert-info no-margin-bottom">
                    <i>
                        {{'As soon as your balance reaches'|trans}} -{{creditLine|roundNumber}} {{'no more jobs will be added to your calendar.'|trans}}
                    </i>
                </div >

                <div class="table-responsive table-transactions">
                    <table class="table table-pelican ">
                        <thead>
                            <tr>
                                <th >{{'Date'|trans }}</th>
                                <th>{{ 'Amount'|trans }}</th>
                                <th>{{ 'Type'|trans }}</th>
                                <th>{{ 'Job'|trans }}</th>
                                <th>{{ 'Job Type'|trans }}</th>
                                <th>{{ 'Job Start'|trans }}</th>
                                <th>{{ 'Comment'|trans }}</th>
                                <th v-if="!isNoviceWorker" class="text-right">{{ 'Supplement' |trans }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <TransactionRow
                                    v-for="transaction in transactions"
                                    v-bind:isNoviceWorker="isNoviceWorker"
                                    v-bind:transaction="transaction"
                                    v-bind:key="transaction.id"
                            >
                            </TransactionRow>
                        </tbody>
                    </table>

                    <div class="text-center">
                        <Spinner v-bind:title="'Getting Transactions Please Wait'|trans" v-show="loading"></Spinner>
                        <div @click="loadMore" v-show="!loading && hasMoreTransactions" class="btn btn-primary align-self-center">
                            {{'Load More Transactions'|trans}}
                        </div>

                        <div class="alert alert-info" v-if="!hasMoreTransactions">
                            {{'Nothing to show'|trans }}
                        </div>
                    </div>

                </div>


            </div>

        </div>
    </div>
</template>

<script>
    import Spinner from '../Spinner';
    import TransactionRow from './TransactionRow';
    import ModalSmall from '../ModalSmall'

    export default {
        props: {
            apiGetTransactionsAndBalance: Function,
            apiGetWorkerDatas: Function,
            workerId : Number,
            initializedOnPelican : Boolean
        },
        data() {
            return {
                loading: false,
                transactions: null,
                isNoviceWorker: false,
                currentBalance: null,
                hasMoreTransactions: true,
                creditLine : null,
                customer : null,
            };
        },
        async created() {
            if (this.$options.filters.trans === undefined) {
                this.$options.filters.trans = text => text;
            }
            this.loadMore();
        },
        methods : {
            async loadMore() {
                this.loading = true;
                let lastTransactionId = null;
                if (this.transactions !== null) {
                    lastTransactionId = this.transactions[this.transactions.length - 1].id;
                }
                const transactionsAndBalance = await this.apiGetTransactionsAndBalance(this.workerId, lastTransactionId); // TODO: catch errors ?
                if (this.transactions === null) {
                    this.transactions = [];
                }

                this.creditLine = transactionsAndBalance.creditLine;
                this.transactions = this.transactions.concat(transactionsAndBalance.transactions);
                this.isNoviceWorker = transactionsAndBalance.isNoviceWorker;
                this.currentBalance = transactionsAndBalance.current_balance;
                this.hasMoreTransactions = transactionsAndBalance.transactions.length !== 0;
                this.loading = false;
            }
        },
        filters:{
            /* @return Number */
            keep2Decimals(number) {
                return number !== null ? number.toFixed(2) : number ;
                //return number.toFixed(2);
            },
            roundNumber(number) {
              return number !== null ? Math.round(number) : number ;
              //return number.toFixed(2);
            },
        },
        components: {
            Spinner,
            TransactionRow,
            ModalSmall
        },
    }
</script>


<style scoped>
    /deep/ .monospaceText{
        font-family:Menlo, Monaco, Consolas, "Courier New", monospace;
    }
    .table-transactions{
        width: 100%;
        overflow:scroll;
        padding-bottom:100px;
        height:450px;
    }

    .modal-style-balance{
        padding:10px;
    }
</style>
